let token = null

const getCsrfToken = () => {
  if (!token) {
    token = document.getElementsByName('csrf-token')[0].content
  }
  return token
}

export default getCsrfToken
